import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';
import MobilePlayer from 'widget/components/players/mobile-player';
import { openVideoPage } from 'widget/redux/client/actions/mobile-overlay-openners/main-openners';


const withOpenVideoPageWhenEnds = WrappedPlayer => {

  @connect(
    null,
    (dispatch, { videoItem }) => ({
      openVideoPage: () => dispatch(openVideoPage(videoItem.id)),
    }),
  )
  class WithOpenVideoPage extends React.Component {

    static propTypes = WrappedPlayer.propTypes;

    static defaultProps = {
      onPlayStart: _.noop,
      onEnded: _.noop,
      onResume: _.noop,
      onFullScreenChanged: _.noop,
    };

    @autobind
    onPlayStart() {
      this.props.onPlayStart();
      this._needToOpenVideoPage = true;
    }

    @autobind
    onResume() {
      this.props.onResume();
      this._needToOpenVideoPage = true;
    }

    @autobind
    onEnded() {
      if (!this._needToOpenVideoPage) {
        return;
      }

      const { onEnded, openVideoPage } = this.props;
      this._needToOpenVideoPage = false;
      onEnded();
      openVideoPage();
    }

    @autobind
    onFullScreenChanged(isOpened) {
      if (isOpened || !this._needToOpenVideoPage) {
        return;
      }

      const { onFullScreenChanged, openVideoPage } = this.props;
      this._needToOpenVideoPage = false;
      onFullScreenChanged(isOpened);
      openVideoPage();
    }

    render() {
      return (
        <WrappedPlayer {...this.props}
                       onPlayStart={this.onPlayStart}
                       onResume={this.onResume}
                       onEnded={this.onEnded}
                       onFullScreenChanged={this.onFullScreenChanged} />
      );
    }
  }

  return WithOpenVideoPage;
};


const MainWidgetMobilePlayer = withOpenVideoPageWhenEnds(MobilePlayer);

export default MainWidgetMobilePlayer;



// WEBPACK FOOTER //
// ./src/widget/components/players/main-widget-mobile-player.js